import React, { useEffect, useState } from "react";
import { AppShell } from "@/components/AppShell";
import { ModuleTable } from "@/components/ModuleTable";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { api } from "@/lib/api";

// Simple internal team directory (HR)
function TeamDirectory() {
  const [team, setTeam] = useState([]);
  useEffect(() => { api.get("/team").then((r) => setTeam(r.data)).catch(() => {}); }, []);
  return (
    <div className="bg-white rounded-lg border border-[#D7C6A9] overflow-hidden">
      <table className="w-full text-sm">
        <thead><tr className="text-left text-[11px] uppercase tracking-wider text-neutral-500 bg-[#FafaF8]"><th className="px-5 py-3">Name</th><th className="px-5 py-3">Email</th><th className="px-5 py-3">Role</th><th className="px-5 py-3">Department</th></tr></thead>
        <tbody>{team.map((t) => (
          <tr key={t.id} data-testid={`hr-team-row-${t.id}`} className="border-t border-[#EEE9DE]"><td className="px-5 py-3.5 font-medium text-neutral-900">{t.name}</td><td className="px-5 py-3.5 text-neutral-600">{t.email}</td><td className="px-5 py-3.5 text-neutral-600">{t.role}</td><td className="px-5 py-3.5 text-neutral-600">{t.department}</td></tr>
        ))}</tbody>
      </table>
    </div>
  );
}

// tabs = [{ key: "vendors", label: "Vendors" }] or [{ custom: <Comp/>, label }]
export function DepartmentPage({ title, tabs }) {
  return (
    <AppShell title={title}>
      {tabs.length === 1 && !tabs[0].custom ? (
        <ModuleTable moduleKey={tabs[0].key} />
      ) : (
        <Tabs defaultValue={tabs[0].value}>
          <TabsList className="bg-[#EEE9DE]">
            {tabs.map((t) => <TabsTrigger key={t.value} value={t.value} data-testid={`dept-tab-${t.value}`} className="data-[state=active]:bg-white data-[state=active]:text-[#F5691C]">{t.label}</TabsTrigger>)}
          </TabsList>
          {tabs.map((t) => <TabsContent key={t.value} value={t.value} className="mt-4">{t.custom || <ModuleTable moduleKey={t.key} />}</TabsContent>)}
        </Tabs>
      )}
    </AppShell>
  );
}

export { TeamDirectory };
